export default {
  Title: 'Netflare blogs',
  AllBlogs: '← All blogs',
};
